import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    toggled: false,
}

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.toggled = action.payload;
    },
    toggleSidebar: (state) => {
      state.toggled = !state.toggled;
    },
  },
});

export const { toggleSidebar, setSidebarCollapsed } = sidebarSlice.actions;
export default  sidebarSlice.reducer;
